
import { ScoutTask, TaskType } from './models'
import { BehaviorSubject } from 'rxjs'
import { PathTestDoc } from './schema/path-test-schema'
import { DriveTestDoc } from './schema/drive-test-schema'
export class ShowRequest {
    viewMode = 'tab'
    id? : string
    task? : ScoutTask | PathTestDoc | DriveTestDoc

    set viewType(t:string) { this._viewType = t.toLowerCase() }
    get viewType() { return this._viewType }
    private _viewType?: string // 'test', 'survey', 'path', etc...

    title = new BehaviorSubject<string>('')

    titleFn = () => {
        const capitalize = (str) => str.replace(/(?:^|\s|-|["'([{])+\S/g, match => match.toUpperCase());
        if ( ['building', 'point' ].includes(this.viewType) ) {
            return `${capitalize(this.viewType)} ${this.id}`
        } else if ( this.viewType == 'volunteer tasks') {
            const title = `Mobile Tests`;
            return title;
        } else if ( ['scout path','scout report'].includes(this.viewType)) {
            const scoutTask = this.task as ScoutTask
            const scoutPath = scoutTask.scoutPaths.find(sp=>sp.id==this.id)
            return `${capitalize(this.viewType)} ${this.task.buildingId} #${scoutPath.pathNumber||'?'}`
        } else if ( this.viewType == 'path test group') {
            let { stage, buildingId } = this.task ? this.task : JSON.parse(this.id)
            const title = `Test(s) ${stage} ${buildingId}`
            return title
        } else if ( this.viewType == 'volunteer task') {
            const title = `Mobile Test`;
            return title
        } else if ( this.viewType == 'user list') {
            const title = `Users`;
            return title
        } else if ( this.viewType == 'volunteer list') {
            const title = `Mobile Users`;
            return title
        } else if ( this.viewType == TaskType.DRIVE_TEST) {
            let { stage, routeId } = this.task ? this.task : JSON.parse(this.id)
            const title = `Drive Test ${stage} ${routeId}`
            return title
        } else if ( this.task?.type == TaskType.SCOUT) {
            return `Scout ${this.task.stage} ${this.task.buildingId}`
        } else if ( this.task?.type == TaskType.PATH_TEST) {
            return `Indoor ${this.task.stage} ${this.task.buildingId}`
        } else if ( this.task ) {
            let title = `${capitalize(this.viewType)} ${this.task.stage} ${this.task.pathId}`
            if ( this.task.cycle ) {
                title += ` (${this.task.cycle})`
            }
            return title
        } else {
            return `${capitalize(this.viewType)}`
        }
    }

    constructor(viewMode:string, viewType:string, id:any, task: ScoutTask|PathTestDoc|DriveTestDoc = null){
        this.viewMode = viewMode
        this.viewType = viewType
        this.id = id
        this.task = task
        this.title.next(this.titleFn())
    }

    public matches = ( other : ShowRequest ) : boolean => {
        let bMatch =  other && this.viewMode == other.viewMode
            && this.viewType == other.viewType && this.id == other.id
        //TBD - if viewInfo has TaskListItem should they be equal too?
        return bMatch
    }
}